/*
 * this is copied from browse-promotions. it is a work in progress. it's merged because the BE
 * isn't ready yet. will finish when adding to campaigns becomes available
 * TODO: migrate classnames
 *  TODO: will migrate the browse promotinos search to use this
 * TODO: make the style more flexible

 * */

import React, { Component } from "react";
import "./show_search.scss";
import { FormControl } from "react-bootstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
  searchShows,
  clearShows,
  searchDirectoryShows,
} from "../../../action_managers/show_search";
import { If } from "react-extras";
import { Row, Col, Grid } from "react-bootstrap";
import {
  itunesCategoriesMap,
  itunesCategoriesSorted,
  itunesCategoryUUIDToName,
} from "../../../data/itunes_categories";
import { searchNames } from "../../../constants/bucketed_audience_size";
import { CSSTransition } from "react-transition-group";
import Spinner from "../../lib/spinner";
import filter from "lodash/filter";
import debounce from "lodash/debounce";
import orderBy from "lodash/orderBy";
import flow from "lodash/fp/flow";
import sortByFP from "lodash/fp/sortBy";
import mapFP from "lodash/fp/map";
import filterFP from "lodash/fp/filter";
import { getActiveCategories } from "../../../action_managers/show_search";
import RedCircleSelect from "../redcircle-select";
import { getImageURL } from "../../../lib/get_image_url";
import { CheckBoxFilter, SliderFilter } from "./filter_components";
import AntTable from "../../../lib/ant_table";
import { formatMoney } from "../../../lib/format-money";
import { primaryColor, primaryColor20 } from "../../../constants/css";
import closeButton from "../../../icons/modal-close-icon.svg";
import { hummanizeNumber } from "../../../lib/numbers";

class ShowSearch extends Component {
  state = {
    searchValue: "",
    bucketedAudienceSize: undefined,
    categoryUUIDs: undefined,
    debouncing: false,
  };

  isAdSearch = () => {
    return this.props.additionalFilters?.showSearchType === "ads";
  };
  componentDidMount() {
    this.restoreToDefualt();
    if (this.isAdSearch()) {
      this.props.getActiveCategories();
    }
  }

  updateSearchText = e => {
    this.setState({ searchValue: e.target.value });
    e.target.value ? this.searchShows() : this.debouncedSearch();
  };

  restoreToDefualt() {
    if (this.props.firstSearchFilters) {
      this.props.searchShows({ ...this.props.additionalFilters, ...this.props.firstSearchFilters });
    } else {
      this.props.clearShows();
    }
  }

  formatRangeQueries = (stateKey, ESKey) => {
    if (!this.state[stateKey]) return;
    return ["min", "max"].reduce((agg, next, index) => {
      agg[next + ESKey] = this.state[stateKey][index];
      return agg;
    }, {});
  };

  debouncedSearch = debounce(() => {
    this.setState({ debouncing: false });
    let searchTerms = {
      ...(this.state.searchValue && { query: this.state.searchValue }),
      ...(this.state.categoryUUIDs && { categoryUUIDs: this.state.categoryUUIDs }),
      ...(this.state.CPM && { minAverageCPM: this.state.CPM[0], maxAverageCPM: this.state.CPM[1] }),
      ...(this.state.weeklyDownloads && {
        minEstimatedWeeklyDownloads: this.state.weeklyDownloads[0],
        maxEstimatedWeeklyDownloads: this.state.weeklyDownloads[1],
      }),
      ...(this.state.episodeDownloads && {
        minAverageEpisodeDownloads: this.state.episodeDownloads[0],
        maxAverageEpisodeDownloads: this.state.episodeDownloads[1],
      }),
      ...this.formatRangeQueries("spotRate", "SpotRate"),
      userUUID: this.props.user.uuid,
      ...(this.props.additionalFilters && { ...this.props.additionalFilters }),
    };

    this.props.extraFilterOptions &&
      this.props.extraFilterOptions.forEach(({ name, searchMapper }) => {
        if (this.state[name]) {
          searchTerms = {
            ...searchTerms,
            ...(searchMapper ? searchMapper(this.state[name]) : { [name]: this.state[name] }),
          };
        }
      });
    // Two cases.
    // 1) All is selected, only search shows of similar size. Defined as shows of same size and one category up/below.
    // 2) Specific size is selected then search `bucketedAudienceSize` to specify single size
    if (!this.state.bucketedAudienceSize) {
      this.props.useDirectoryShows &&
        this.props.searchDirectoryShows({
          ...(this.state.searchValue && { query: this.state.searchValue }),
          ...(this.state.categoryUUIDs && { categoryUUIDs: [this.state.categoryUUIDs] }),
        });
      searchTerms.bucketedAudienceSizes = this.props.bucketedAudienceSizes;
    } else {
      searchTerms.bucketedAudienceSize = this.state.bucketedAudienceSize;
    }
    this.props.searchShows(searchTerms);
  }, 500);

  searchShows = () => {
    this.setState({ debouncing: true });
    this.debouncedSearch();
  };

  getFilterDropdown = setting => {
    const dropdowns = {
      categoryUUIDs: ({ confirm }) => (
        <CheckBoxFilter
          options={this.getCategories()}
          onChange={this.handleDetailSelect(setting)}
          close={confirm}
          values={this.state[setting]}
        />
      ),
      weeklyDownloads: ({ confirm }) =>
        this.sliderFilter(setting, { close: confirm, min: 450, max: 350000 }),
      CPM: ({ confirm }) =>
        this.sliderFilter(setting, {
          close: confirm,
          min: 400,
          max: 5500,
          formatNumber: formatMoney,
        }),
      episodeDownloads: ({ confirm }) =>
        this.sliderFilter(setting, { close: confirm, min: 500, max: 200000 }),
      spotRate: ({ confirm }) =>
        this.sliderFilter(setting, {
          close: confirm,
          min: 500,
          max: 400000,
          formatNumber: formatMoney,
        }),
    };

    return dropdowns[setting] || null;
  };

  sliderFilter = (key, props) => (
    <SliderFilter values={this.state[key]} onChange={this.handleDetailSelect(key)} {...props} />
  );

  renderSearchResult = () => {
    if (this.props.renderer) {
      return this.props.renderer(this.getResults());
    }
    if (this.props.columns) {
      const columns = this.props.columns.map(column => {
        return {
          ...column,
          ...(column.filterDropdown && {
            filterDropdown:
              typeof column.filterDropdown === "string" || !!column.filterDropdown.dropdown
                ? this.getFilterDropdown(column.filterDropdown)
                : column.filterDropdown,
          }),
          title: column.titleMapper ? column.titleMapper(this.state) : column.title,
        };
      });
      return (
        <AntTable
          loading={this.props.isLoading}
          dataSource={this.getResults()}
          columns={columns}
          rowClassName={"black-text"}
          pagination={false}
          {...this.props.tableProps}
        />
      );
    }
    if (!this.getResults().length || this.props.isLoading) {
      return <Spinner isLoading={this.props.isLoading} />;
    }

    return this.getResults().map(show => {
      const content = this.props.renderSearchRow
        ? this.props.renderSearchRow(show)
        : DefaultSearchResultRow(show);

      if (this.props.linkTo && this.props.linkTo(show)) {
        var linkTo = show.isDirectoryShow
          ? `/promotions/directory-shows/${show.uuid}`
          : `/promotions/shows/${show.uuid}`;
        return (
          <Link to={linkTo} className="no-style-link" key={show.uuid}>
            <div className={"show-search__search-result"}>{content}</div>
          </Link>
        );
      }

      return (
        <div key={show.uuid} className={"show-search__search-result"}>
          {content}
        </div>
      );
    });
  };

  handleDetailSelect = filterKey => e => {
    let value;
    if (Array.isArray(e)) {
      value = e;
    } else {
      value = e?.value === "all" || e === null ? undefined : e?.value;
    }
    this.setState({ [filterKey]: value });
    this.searchShows();
  };

  getCategories = () => {
    if (this.isAdSearch()) {
      return flow(
        filterFP(uuid => itunesCategoriesMap[uuid]),
        mapFP(uuid => {
          return { value: uuid, label: itunesCategoriesMap[uuid]?.name ?? "" };
        }),
        sortByFP("label")
      )(this.props.activeAdCategories);
    } else {
      return itunesCategoriesSorted.map(({ name, uuid }) => ({
        value: uuid,
        label: name,
      }));
    }
  };

  detailedSearch = () => {
    if (!this.state.showExtraFilters) return null;
    let audienceSizes = searchNames;
    if (this.props.bucktedAudienceSizes) {
      audienceSizes = filter(audienceSizes, o => {
        return this.props.bucketedAudienceSizes.includes(o.value);
      });
    }

    const filters = [
      {
        name: "bucketedAudienceSize",
        placeholder: "Weekly Downloads",
        options: [
          { name: "All Valid Weekly Downloads", value: "all" },
          ...audienceSizes,
        ].map(({ name, value }) => ({ value, label: name })),
      },
      ...(this.props.extraFilterOptions ?? []),
    ];

    return (
      <Row className="detailed-search-row flex-row-container p-hxs">
        {filters.map(({ options, name, placeholder, multiSelect }) => {
          return (
            <RedCircleSelect
              isMulti={multiSelect}
              key={name}
              placeholder={placeholder}
              className={"flex-1"}
              options={options}
              onChange={this.handleDetailSelect(name)}
            />
          );
        })}
      </Row>
    );
  };
  getResults = () => {
    const search = orderBy(this.props.search, ["estimatedWeeklyDownloads"], ["desc"]);
    return this.props.useDirectoryShows
      ? search.concat(this.props.directoryShowsSearchResults)
      : search;
  };

  renderFilterTags = () => {
    let filtersTagsText = [];
    if (this.state.categoryUUIDs) {
      const categoryTags = this.state.categoryUUIDs.map(uuid => ({
        display: `Category: ${itunesCategoryUUIDToName(uuid)}`,
        onClick: () => {
          const categories = new Set(this.state.categoryUUIDs);
          categories.delete(uuid);
          this.handleDetailSelect("categoryUUIDs")(
            categories.size ? Array.from(categories) : undefined
          );
        },
      }));
      filtersTagsText = filtersTagsText.concat(categoryTags);
    }
    const additionalTagsTexts = [
      { key: "weeklyDownloads", display: "Weekly Downloads", formatNumber: hummanizeNumber },
      { key: "CPM", display: "CPM", formatNumber: formatMoney },
      { key: "episodeDownloads", display: "Episode Downloads", formatNumber: hummanizeNumber },
      { key: "spotRate", display: "Spot Rate", formatNumber: formatMoney },
    ]
      .filter(({ key }) => this.state[key])
      .map(({ key, display, formatNumber }) => ({
        onClick: () => {
          this.handleDetailSelect(key)(undefined);
        },
        display: `${display}: ${this.state[key].map(formatNumber).join(" - ")}`,
      }));

    filtersTagsText = filtersTagsText.concat(additionalTagsTexts);
    return (
      <div className={"flex-row-container align-center"}>
        {filtersTagsText.map(({ display, onClick }) => (
          <div
            key={display}
            className={"p-hxs p-vxxxs m-rxxs m-bs rounded-corners-large"}
            style={{
              fontSize: 13,
              background: primaryColor20,
              border: `1px solid ${primaryColor}`,
            }}>
            <span className={"bump-down--1"}>{display}</span>
            <img
              style={{ height: 18, cursor: "pointer", marginLeft: 4 }}
              src={closeButton}
              onClick={onClick}
              alt="close"
            />
          </div>
        ))}
      </div>
    );
  };

  render() {
    return (
      <CSSTransition in={this.props.show} classNames={"browse-search"} timeout={500} unmountOnExit>
        <Grid fluid>
          <Row>
            <Col xs={12}>
              <FormControl
                type="text"
                onChange={this.updateSearchText}
                value={this.state.searchValue}
                className="browse-promotion-search__search-box"
                placeholder="Search"
              />
            </Col>
          </Row>
          {this.detailedSearch()}
          {this.renderFilterTags()}
          {this.renderSearchResult()}
          <If
            condition={
              !this.props.search.length &&
              !!this.state.searchValue &&
              !this.props.isLoading &&
              !this.state.debouncing
            }>
            <div className="text-center browse-promotion-search__no-results">
              We couldn
              {"'"}t find any podcasts that match your search.
            </div>
          </If>
          <If
            condition={
              !this.props.search.length &&
              !this.state.searchValue &&
              !this.props.isLoading &&
              !this.state.debouncing
            }>
            <div className="text-center browse-promotion-search__no-results">
              Start your search for a partner podcast.
            </div>
          </If>
        </Grid>
      </CSSTransition>
    );
  }
}

export const DefaultShowSearchImage = show => {
  return (
    <div
      className="show-search__search-picture"
      style={{
        backgroundImage: "url(" + getImageURL(show.imageURL, "64x64") + ")",
      }}
    />
  );
};

export const DefaultSearchResultRow = show => {
  return (
    <div className={"browse-promotion-search__search-result"}>
      {DefaultShowSearchImage(show)}
      <span className="browse-promotion-search__title">{show.title}</span>
      <span className="browse-promotion-search__spacer" />
      <span className="browse-promotions-search__arrow glyphicon glyphicon-chevron-right" />
    </div>
  );
};

export default connect(
  state => {
    return {
      search: state.browsePromotion.search.results,
      directoryShowsSearchResults: state.browsePromotion.searchDirectoryShows.results,
      isLoading: state.browsePromotion.search.isLoading,
      user: state.user.user,
      activeAdCategories: state.browsePromotion.activeAdCategories.categories,
    };
  },
  {
    getActiveCategories,
    searchShows,
    searchDirectoryShows,
    clearShows,
  }
)(ShowSearch);
